import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getFacility = async (facilityId) => {
  return await request.get(
    `/RentPlace/rental_house/${facilityId}`,
    {},
    'При загрузке объекта произошла ошибка'
  );
};

const useFacility = (facilityId) =>
  useQuery([queries.facility, facilityId], () => getFacility(facilityId), {
      placeholderData: {},
      enabled: !!facilityId,
  });

export default useFacility;
